import "react-quill/dist/quill.snow.css";
import { Router as MainRoutes } from "./routing/Router";

const App = () => {
  return <MainRoutes />;
};

export default App;
